import React, { createElement } from 'react'

//Node Modules
import { domToReact } from 'html-react-parser'

//Components
import ContentLink from 'components/ContentLink'

//Types
import { HELP_DOCSET_ALIAS} from 'util/constants'

export default (node:any, params:any, options:any) => {
  const docsetAlias = node.attribs['data-docset-id']
  const docsetCFR = node.attribs['data-docset-version']
  const cdcAlias = node.attribs['data-cdc-id']
  const cdcCFR = node.attribs['data-cdc-version']
  const activeCDC = node.attribs['data-active-cdc']
  const className = node.attribs['class']
  const id = node.attribs['id']
  const target = node.attribs['target']

  const [pageLink, fragment] = node.attribs.href.split('#')
  const children = node.children

  const page = pageLink || params.page

  const help= docsetAlias === HELP_DOCSET_ALIAS

  return createElement(
    ContentLink as React.FunctionComponent, 
    { 
      docsetAlias, 
      docsetCFR, 
      cdcAlias,
      cdcCFR,
      activeCDC,
      page,
      fragment,
      className,
      id,
      target,
      help
    } as any, 
    domToReact(children, options)
  )
}